import { render, staticRenderFns } from "./EmptyStateCard.vue?vue&type=template&id=36be4d47&"
import script from "./EmptyStateCard.vue?vue&type=script&lang=js&"
export * from "./EmptyStateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports